// src/modules/app-views/offers/pages/Document/tabs/RecordTab/OfferBasicCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { Card, Col, Row } from 'antd';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import appService from 'services/appService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OfferBasicCard = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const statusOptions = [
    { value: 'draft', label: translateX('draft') },
    { value: 'active', label: translateX('active') },
    { value: 'paused', label: translateX('paused') },
    { value: 'finished', label: translateX('finished') },
  ];

  const typeOptions = useMemo(() => {
    const types = appService.getModulePreferences({ category: 'types' }) || [];
    return types
      .filter(t => !t.removed)
      .map(t => ({ value: t.uid, label: t.name }));
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Card title={translateX('offer_basic_data')}>
      <Row gutter={[16, 0]}>
        <Col xs={24} md={16}>
          <SimpleInput
            name="name"
            label="name"
            required
          />
        </Col>

        <Col xs={24} md={8}>
          <SimpleSelect
            name="status"
            label="status"
            options={statusOptions}
            required
          />
        </Col>
      </Row>

      {/*<Row gutter={[16, 0]}>*/}
      {/*  <Col xs={24} md={12}>*/}
      {/*    <SimpleSelect*/}
      {/*      name="type"*/}
      {/*      label="type"*/}
      {/*      options={typeOptions}*/}
      {/*      required*/}
      {/*    />*/}
      {/*  </Col>*/}
      {/*  <Col xs={24} md={12} />*/}
      {/*</Row>*/}

      <Row gutter={[16, 0]}>
        <Col xs={24}>
          <SimpleTextArea
            name="shortDescription"
            label="short_description"
            required
            rows={3}
          />
        </Col>
      </Row>
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OfferBasicCard;
